import { render, staticRenderFns } from "./username.vue?vue&type=template&id=30f4530a&"
import script from "./username.vue?vue&type=script&lang=js&"
export * from "./username.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports